// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore,collection,setDoc,doc,getDocs,where,query } from 'firebase/firestore/lite'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCLd--8nK8sktnxi73TPmFidFEREiJ2h8A",
  authDomain: "my-portfolio-7cbda.firebaseapp.com",
  projectId: "my-portfolio-7cbda",
  storageBucket: "my-portfolio-7cbda.appspot.com",
  messagingSenderId: "202441954921",
  appId: "1:202441954921:web:3faf31233d0c01c6f934f8",
  measurementId: "G-F1ECGEV8LZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);



export { app,getFirestore,collection,setDoc,getDocs,doc,where,query }